import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Constant from '@/common/constant/Constant';

import Utils from '@/common/utils/utils';

import './ListTicket.css';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import { userAtom } from '@/state/atom/userAtom';
import { DialogConfirmAcceptAnonymousQaTicket } from './listTicketDialog/DialogConfirmAcceptAnonymousQaTicket';
import { DialogConfirmRejectAnonymousQaTicket } from './listTicketDialog/DialogConfirmRejectAnonymousQaTicket';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { UpdateAnonymousQaTicketErrorModal } from '@/component/common/modal/UpdateAnonymousQaTicketErrorModal';
import { DialogNotificationTicketApprovedBefore } from './listTicketDialog/DialogNotificationTicketApprovedBefore';
import { DialogConfirmForceEditTicket } from './listTicketDialog/DialogConfirmForceEditTicket';
import { fieldListOfProjectSelector } from '@/state/selector/formSelector';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import { onScrollHelpdeskTicketList } from './handler/HelpDeskTicketListHandler';
import DetailTicketList from './DetailTicketList';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

// Tabs
const TabPanel = props => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

export default function List(props) {
    const {
        API,
        ticketListType,
        ticketList,
        setTicketList,
        viewStructure,
        setViewStructure,
        setTriggerSearch,
        setOptionSearchTime,
        defaultDrillDownData,
        inputKeyWordRef,
        lastedCountList,
        setLastedCountList,
        fromTicket,
        setFromTicket,
        isLoading,
        setIsLoading,
        keywordSearch,
        setKeywordSearch,
        setDrillDownDataSelected,
        projectUserList,
        panelId,
        setIsLoadingDrillDown,
        setDrillDownData,
        setSugguestionList,
        setDefaultDrillDownData,
        getNextPageQaList,
        isScrollLoad,
        setTotalTickets,
        triggerSearch
    } = props;
    // Popover change assignee
    const [assignListPopover, setAssignListPopover] = useState(null);
    const isOpenAssignListPopover = Boolean(assignListPopover);
    const idAssignListPopover = isOpenAssignListPopover ? 'change-assign' : '';
    const [openAssignListPopoverId, setOpenAssignListPopoverId] = useState(null);

    // Common fieldList recoil
    const fieldListInState = useRecoilValue(fieldListOfProjectSelector);
    // const [fieldListInState, setFieldListInState] = useRecoilState(fieldListAtom);

    const corporationId = localStorageUtil.getAffiliationOrganization();
    const currentProjectId = localStorageUtil.getSelectedProjectId();
    const [value] = useState(0);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const userDetail = useRecoilValue(userAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const isCustomerListTicket = ticketListType === Constant.TYPE_GET_TICKET_LIST.CUSTOMER;
    const isHelpdeskListTicket = ticketListType === Constant.TYPE_GET_TICKET_LIST.HELPDESK;

    const [isConfirmRejectTicket, setIsConfirmRejectTicket] = useState(false);
    const [isConfirmAcceptTicket, setIsConfirmAcceptTicket] = useState(false);
    const [isOpenModalApproveRejectError, setIsOpenModalApproveRejectError] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState({});
    const [isTicketUpdatedBefore, setIsTicketUpdatedBefore] = useState(false);
    const [approvalFlagAfterUpdated, setApprovalFlagAfterUpdated] = useState();
    const [confirmForceEditTicket, setConfirmForceEditTicket] = useState({
        method: 0,
        requestDto: {}
    });
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const selectedProject = useRecoilValue(projectInuseDetailAtom);
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    
    const onScrollTicketList = async event => {
        if (ticketListType === Constant.TYPE_GET_TICKET_LIST.HELPDESK) {
            let argsOnScrollHelpdeskList = {
                ...props,
                corporationId,
                projectId: currentProjectId,
                userDetail,
                ticketList: ticketList,
                setTicketList: setTicketList,
                isLoading: isLoading,
                setIsLoading: setIsLoading,
                fieldListInState,
                userId: userDetail.id,
                viewStructure,
                setViewStructure,
                setOptionSearchTime,
                defaultDrillDownData,
                inputKeyWordRef,
                lastedCountList,
                setLastedCountList,
                fromTicket,
                setFromTicket,
                keywordSearch,
                setKeywordSearch,
                setDrillDownDataSelected,
                setIsLoadingDrillDown,
                setDrillDownData,
                setSugguestionList,
                setDefaultDrillDownData,
                setTotalTickets
            };
            await onScrollHelpdeskTicketList(event, argsOnScrollHelpdeskList);
        } else if (ticketListType === Constant.TYPE_GET_TICKET_LIST.CUSTOMER) {
            let element = event.target;
            if (
                element.offsetHeight + element.scrollTop > element.scrollHeight &&
                (lastedCountList === Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD || isScrollLoad === true)
            ) {
                getNextPageQaList();
            }
        }
    };

    return (
        <div className="groupTicket" data-cy="list-ticket-panel">
            <div className="groupTicket-content">
                <TabPanel className="tabPanel-content" value={value} index={0}>
                    {/* <div className="scrollBar-main"> */}
                    <div className="ticket-lst" onScroll={e => onScrollTicketList(e)}>
                        <ul>
                            {!Utils.isEmptyArray(ticketList) &&
                                ticketList.map((item, i) => {
                                    return (
                                        <DetailTicketList
                                            key={`detail-ticket-list-item-${item.id}`}
                                            {...props}
                                            ticket={item}
                                            isHelpdeskListTicket={isHelpdeskListTicket}
                                            isCustomerListTicket={isCustomerListTicket}
                                            selectedTicket={selectedTicket}
                                            setSelectedTicket={setSelectedTicket}
                                            setConfirmForceEditTicket={setConfirmForceEditTicket}
                                            setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                                            setIsConfirmAcceptTicket={setIsConfirmAcceptTicket}
                                            setIsConfirmRejectTicket={setIsConfirmRejectTicket}
                                            setIsLoading={setIsLoading}
                                            setTriggerSearch={setTriggerSearch}
                                            projectUserList={projectUserList}
                                            panelId={panelId}
                                            assignListPopover={assignListPopover}
                                            setAssignListPopover={setAssignListPopover}
                                            isOpenAssignListPopover={isOpenAssignListPopover}
                                            idAssignListPopover={idAssignListPopover}
                                            openAssignListPopoverId={openAssignListPopoverId}
                                            setOpenAssignListPopoverId={setOpenAssignListPopoverId}
                                            triggerSearch={triggerSearch}
                                        />
                                    );
                                })}
                        </ul>
                        {/* </div> */}
                    </div>
                </TabPanel>
            </div>

            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <DialogConfirmForceEditTicket
                API={API}
                confirmForceEditTicket={confirmForceEditTicket}
                setConfirmForceEditTicket={setConfirmForceEditTicket}
                setIsLoading={setIsLoading}
                setAssignListPopover={setAssignListPopover}
                panelList={panelList}
                setPanelList={setPanelList}
                triggerReload={setTriggerSearch}
                setTriggerSearch={setTriggerSearch}
                panelId={panelId}
            />
            <DialogConfirmRejectAnonymousQaTicket
                API={API}
                parentPanelScreen={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                isConfirmRejectTicket={isConfirmRejectTicket}
                selectedTicket={selectedTicket}
                setSelectedTicket={setSelectedTicket}
                setIsConfirmRejectTicket={setIsConfirmRejectTicket}
                setIsLoading={setIsLoading}
                userDetail={userDetail}
                corporationId={corporationId}
                isOpenModalApproveRejectError={isOpenModalApproveRejectError}
                setIsOpenModalApproveRejectError={setIsOpenModalApproveRejectError}
                setApprovalFlagAfterUpdated={setApprovalFlagAfterUpdated}
                isTicketUpdatedBefore={isTicketUpdatedBefore}
                setIsTicketUpdatedBefore={setIsTicketUpdatedBefore}
                panelList={panelList}
                setPanelList={setPanelList}
                closePanelTab={closePanelTab}
                triggerReload={setTriggerSearch}
                setTriggerSearch={setTriggerSearch}
                isConfirmAcceptTicket={isConfirmAcceptTicket}
                setIsConfirmAcceptTicket={setIsConfirmAcceptTicket}
            />
            <DialogConfirmAcceptAnonymousQaTicket
                API={API}
                parentPanelScreen={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                isConfirmAcceptTicket={isConfirmAcceptTicket}
                setIsConfirmAcceptTicket={setIsConfirmAcceptTicket}
                setIsLoading={setIsLoading}
                userDetail={userDetail}
                selectedTicket={selectedTicket}
                setSelectedTicket={setSelectedTicket}
                corporationId={corporationId}
                setIsOpenModalApproveRejectError={setIsOpenModalApproveRejectError}
                setApprovalFlagAfterUpdated={setApprovalFlagAfterUpdated}
                isTicketUpdatedBefore={isTicketUpdatedBefore}
                setIsTicketUpdatedBefore={setIsTicketUpdatedBefore}
                panelList={panelList}
                setPanelList={setPanelList}
                closePanelTab={closePanelTab}
                triggerReload={setTriggerSearch}
                setTriggerSearch={setTriggerSearch}
                isConfirmRejectTicket={isConfirmRejectTicket}
                setIsConfirmRejectTicket={setIsConfirmRejectTicket}
                isOpenModalApproveRejectError={isOpenModalApproveRejectError}
                selectedProject = {selectedProject}
                corporationDetail={corporationDetail}

            />
            <DialogNotificationTicketApprovedBefore
                API={API}
                parentPanelScreen={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                setIsLoading={setIsLoading}
                corporationId={corporationId}
                isTicketUpdatedBefore={isTicketUpdatedBefore}
                setIsTicketUpdatedBefore={setIsTicketUpdatedBefore}
                approvalFlagAfterUpdated={approvalFlagAfterUpdated}
                setApprovalFlagAfterUpdated={setApprovalFlagAfterUpdated}
                triggerReload={setTriggerSearch}
                setTriggerSearch={setTriggerSearch}
                panelList={panelList}
                setPanelList={setPanelList}
                selectedTicket={selectedTicket}
                setSelectedTicket={setSelectedTicket}
                closePanelTab={closePanelTab}
            />
            {/* <UpdateAnonymousQaTicketErrorModal
                isOpen={isOpenModalApproveRejectError}
                setIsOpen={setIsOpenModalApproveRejectError}
                onSubmit={onSubmitConfirmModalApproveRejectError}
            /> */}
            <DataChangePleaseReloadModal
                isOpen={isOpenModalApproveRejectError}
                setIsOpen={setIsOpenModalApproveRejectError}
            />
        </div>
    );
}
